import { settings } from './allauth'

export function safeReturnPath (value) {
  if (!value || !value.startsWith('/') || value.startsWith('//') ||
      value.includes('\\') || [...value].some(char => char.charCodeAt(0) < 32)) return '/'
  const url = new URL(value, window.location.origin)
  if (url.origin !== window.location.origin ||
      /^\/(?:auth|_allauth)\//.test(url.pathname) ||
      ['/account/login', '/account/logout', '/account/provider/callback'].includes(url.pathname.replace(/\/$/, ''))) return '/'
  return value
}

export function startMicrosoftLogin (next) {
  const query = new URLSearchParams({ next: safeReturnPath(next) })
  window.location.replace(`${settings.baseUrl}/auth/sso?${query}`)
}
